// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.bracket-game-container {
  width: 168px;
  height: 123px;
  margin-right: 24px;
  display: block;
  flex-direction: row;
  position: relative;
}

.conference-title-container {
  display: flex;
  justify-content: space-between;
  width: 95%;
  max-width: 1290px;
  margin: 32px auto;
}
@media screen and (max-width: 925px) {
  .conference-title-container {
    padding-left: 25px;
  }
}

.conference-title {
  color: #CECECE;
  font-family: Inter;
  font-size: 48px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
}

@media screen and (max-width: 925px) {
  .conference-title.right {
    display: none;
  }
}

.conference-title-container.mobile {
  display: none;
}
@media screen and (max-width: 925px) {
  .conference-title-container.mobile {
    display: block;
  }
}

.conference-title.mobile {
  display: none;
}
@media screen and (max-width: 925px) {
  .conference-title.mobile {
    display: block;
    text-align: left;
  }
}

.bracketBox {
  width: 168px;
  padding: 8px 8px;
  border-radius: 8px;
  border-right: 1px solid #efefef;
  border-top: 1px solid #efefef;
  border-left: 1px solid #efefef;
  border-bottom: 1px solid #efefef;
  background: #FFF;
  box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.15);
}

input[type=radio]:checked {
  background-color: #002129;
}

.bracket-line-bottom {
  height: 68px;
  width: 12px;
  border-bottom: 1px solid #9C9C9C;
  border-right: 1px solid #9C9C9C;
  position: absolute;
  right: -12px;
  top: -15px;
}

.bracket-line-top {
  height: 68px;
  width: 12px;
  border-top: 1px solid #9C9C9C;
  border-right: 1px solid #9C9C9C;
  position: absolute;
  right: -12px;
  top: 55px;
}

.row-text {
  margin-bottom: 8px;
  font-size: 16px;
}

.bottom-text {
  margin-top: 8px;
  font-size: 16px;
}

.team-section {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0px;
}

.team-name {
  flex: 1 1;
  font-size: 12px;
}

/* Score container */
.team-score-container {
  flex-shrink: 0; /* Prevents the score container from stretching */
}

/* Bracket team container */
.bracket-team-container {
  display: flex;
  width: 146px;
  align-items: center;
  gap: var(--1, 8px);
  border-radius: var(--1, 8px);
  background: #FFF;
}

/* Team logo */
.team-logo-svg {
  width: 16px;
  height: 16px;
  fill: #EDEDED;
  margin-right: 10px;
}

/* Team seed */
.team-seed {
  width: 14px;
  height: 15px;
  color: #002129;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin-right: 10px;
}

.dropdown-select {
  color: #002129;
  text-align: center;
  font-family: Inter;
  font-size: 8px;
  font-style: normal;
  font-weight: 500;
  width: 137px;
  line-height: normal;
  margin-bottom: 10px;
}

/* Team name */
.team-name {
  width: 87px;
  height: 15px;
  color: #002129;
  font-family: Inter;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  white-space: nowrap;
}

.no-team-name {
  width: 100%;
  height: 12px;
  fill: #D9D9D9;
}

.round-two-box-one {
  margin-top: 60px;
}
.round-two-box-one .bracket-line-top {
  height: 115px;
  width: 12px;
  border-top: 1px solid #9C9C9C;
  border-right: 1px solid #9C9C9C;
  position: absolute;
  right: -12px;
  top: 55px;
}

.back-line {
  border-bottom: 1px solid #9C9C9C;
  position: absolute;
  width: 13px;
  left: -13px;
  top: 51px;
}

.column-one .bracket-game-container .back-line {
  display: none;
}

.column-two .bracket-right-side-bottom .back-line {
  right: -13px;
  left: unset;
}
@media screen and (max-width: 925px) {
  .column-two .bracket-right-side-bottom .back-line {
    left: -13px;
    right: unset;
  }
}

.column-two .bracket-right-side-top .back-line {
  right: -13px;
  left: unset;
}
@media screen and (max-width: 925px) {
  .column-two .bracket-right-side-top .back-line {
    left: -13px;
    right: unset;
  }
  .column-final {
    margin-top: -201px;
  }
}

.round-three-box-one.bracket-right-side-top .back-line {
  display: none;
}

@media screen and (max-width: 925px) {
  .bracket-game-container.round-final.bracket-right-side-top .bracket-line-bottom {
    display: none;
    margin-right: 20px;
  }
}

@media screen and (min-width: 925px) {
  .column-final {
    margin-top: 35px;
  }
}

.champ-box {
  width: 84px;
  height: 84px;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  margin: 0px auto 0 auto;
  border: 1px solid #efefef;
  box-shadow: 0 0 5px #bababa;
  background: #fff;
}

.champ-box img {
  width: 85%;
  margin: 10px auto;
  display: block;
}

.champ-name {
  background: #F2F2F2;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  box-shadow: 0 0 5px #bababa;
  width: 84px;
  margin: 0 auto;
  color: #ffffff;
}

.save-picks-btn {
  background-color: #00AAD1 !important;
  color: #ffffff !important;
  font-weight: 700 !important;
}

.round-two-box-two {
  margin-top: 125px;
}
.round-two-box-two .bracket-line-bottom {
  height: 140px;
  width: 12px;
  border-bottom: 1px solid #9C9C9C;
  border-right: 1px solid #9C9C9C;
  position: absolute;
  right: -12px;
  top: -79px;
}

.round-final {
  margin-right: 11px;
  margin-top: 20px;
}

.round-three-box-one.bracket-right-side-top {
  margin-right: 23px;
}
.round-three-box-one.bracket-right-side-top .bracket-line-bottom {
  border-right: none;
}
@media screen and (max-width: 925px) {
  .round-three-box-one.bracket-right-side-top .bracket-line-bottom {
    left: -13px;
    right: unset;
  }
}

.round-three-box-one .bracket-line-bottom {
  border-right: none;
}

.round-final.bracket-right-side-top .bracket-line-bottom {
  border-right: none;
}

@media screen and (min-width: 925px) {
  .bracket-right-side-bottom .bracket-line-bottom {
    height: 68px;
    width: 12px;
    border-bottom: 1px solid #9C9C9C;
    border-right: none;
    border-left: 1px solid #9C9C9C;
    position: absolute;
    left: -12px;
    top: -15px;
  }
  .bracket-right-side-top .bracket-line-top {
    height: 115px;
    width: 12px;
    border-top: 1px solid #9C9C9C;
    border-right: none;
    border-left: 1px solid #9C9C9C;
    position: absolute;
    left: -12px;
    top: 55px;
  }
  .round-two-box-two.bracket-right-side-bottom {
    margin-top: 125px;
  }
  .round-two-box-two.bracket-right-side-bottom .bracket-line-bottom {
    height: 140px;
    width: 12px;
    border-bottom: 1px solid #9C9C9C;
    border-right: none;
    border-left: 1px solid #9C9C9C;
    position: absolute;
    left: -12px;
    top: -79px;
  }
}

.round-three-box-one {
  margin-top: 185px;
  margin-right: 0;
}

.bracket-box-container {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
  min-width: 1400px;
}
.bracket-box-container .bottom-bracket {
  flex-direction: row-reverse;
}
@media screen and (max-width: 925px) {
  .bracket-box-container {
    min-width: 0;
    overflow-y: overlay;
    display: block;
    padding-left: 25px;
  }
  .bracket-box-container .bottom-bracket {
    flex-direction: row;
  }
}

.bracket-box-wrapper {
  width: 100%;
  overflow-x: auto;
}

@media screen and (min-width: 925px) {
  .column-one .bracket-right-side-top, .bracket-right-side-bottom {
    margin-right: 0;
  }
}

@media screen and (max-width: 925px) {
  .bracket-game-container.round-three-box-one .bracket-line-bottom {
    height: 232px;
    width: 12px;
    border-top: 1px solid #9C9C9C;
    border-bottom: none;
    border-right: 1px solid #9C9C9C;
    position: absolute;
    right: -11px;
    top: 54px;
  }
  .bracket-game-container.round-three-box-one.bracket-right-side-top .bracket-line-bottom {
    border-bottom: none;
    border-right: none;
    position: absolute;
    width: 13px;
    left: -13px;
    top: 51px;
  }
  .bracket-game-container.round-three-box-one.bracket-right-side-top .back-line {
    position: absolute;
    width: 11px;
    right: -11px;
    top: -210px;
    display: block;
    left: unset;
    border-bottom: 1px solid #9C9C9C;
    border-right: 1px solid #9C9C9C;
    height: 262px;
  }
}

.userpick-content {
  display: flex;
  justify-content: center;
}

.tiebreaker-modal {
  background-color: white;
  width: 300px;
  height: 500px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
}`, "",{"version":3,"sources":["webpack://./src/components/Brackets/BracketBox.scss"],"names":[],"mappings":"AAKA;EACE,YAAA;EACA,aAAA;EACA,kBAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;AAJF;;AAgBA;EACE,aAAA;EACA,8BAAA;EACA,UAAA;EACA,iBAAA;EACA,iBAAA;AAbF;AAcE;EANF;IAOI,kBAAA;EAXF;AACF;;AAaA;EACE,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;AAVF;;AAaE;EADF;IAEI,aAAA;EATF;AACF;;AAYA;EACE,aAAA;AATF;AAUE;EAFF;IAGI,cAAA;EAPF;AACF;;AAWA;EACE,aAAA;AARF;AASE;EAFF;IAGI,cAAA;IACA,gBAAA;EANF;AACF;;AASA;EACE,YAAA;EACA,gBAAA;EACA,kBAAA;EACA,+BAAA;EACA,6BAAA;EACA,8BAAA;EACA,gCAAA;EACA,gBAAA;EACA,+CAAA;AANF;;AAQA;EACE,yBAAA;AALF;;AAOA;EACE,YAAA;EACA,WAAA;EACA,gCAAA;EACA,+BAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;AAJF;;AAMA;EACE,YAAA;EACA,WAAA;EACA,6BAAA;EACA,+BAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;AAHF;;AAME;EACE,kBAAA;EACA,eAAA;AAHJ;;AAME;EACE,eAAA;EACA,eAAA;AAHJ;;AAOE;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;AAJJ;;AAOE;EACE,SAAA;EACA,eAAA;AAJJ;;AAOE,oBAAA;AACF;EACE,cAAA,EAAA,iDAAA;AAJF;;AAOE,2BAAA;AACF;EACI,aAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,4BAAA;EACA,gBAAA;AAJJ;;AAOE,cAAA;AACA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;AAJJ;;AAOE,cAAA;AACA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;AAJJ;;AAOE;EACE,cAAA;EACA,kBAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,mBAAA;AAJJ;;AAOE,cAAA;AACA;EACE,WAAA;EACA,YAAA;EACA,cAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,mBAAA;AAJJ;;AAOE;EACE,WAAA;EACA,YAAA;EACA,aAAA;AAJJ;;AAOE;EACE,gBAAA;AAJJ;AAKI;EACE,aAAA;EACA,WAAA;EACA,6BAAA;EACA,+BAAA;EACA,kBAAA;EACA,YAAA;EACA,SAAA;AAHN;;AAOE;EACE,gCAAA;EACA,kBAAA;EACA,WAAA;EACA,WAAA;EACA,SAAA;AAJJ;;AAOA;EACE,aAAA;AAJF;;AAOA;EACE,YAAA;EACA,WAAA;AAJF;AAKE;EAHF;IAII,WAAA;IACA,YAAA;EAFF;AACF;;AAIA;EACE,YAAA;EACA,WAAA;AADF;AAEE;EAHF;IAII,WAAA;IACA,YAAA;EACF;EAGF;IAEI,kBAAA;EACF;AALF;;AAQA;EACE,aAAA;AACF;;AAGE;EADF;IAEI,aAAA;IACA,kBAAA;EACF;AACF;;AAGI;EADF;IAEI,gBAAA;EACJ;AACF;;AAGE;EACE,WAAA;EACA,YAAA;EACA,2BAAA;EACA,4BAAA;EACA,uBAAA;EACA,yBAAA;EACA,2BAAA;EACA,gBAAA;AAAJ;;AAGE;EACE,UAAA;EACA,iBAAA;EACA,cAAA;AAAJ;;AAGE;EACE,mBAAA;EACA,8BAAA;EACA,+BAAA;EACA,2BAAA;EACA,WAAA;EACA,cAAA;EACA,cAAA;AAAJ;;AAGE;EACE,oCAAA;EACA,yBAAA;EACA,2BAAA;AAAJ;;AAEE;EACE,iBAAA;AACJ;AAEI;EACE,aAAA;EACA,WAAA;EACA,gCAAA;EACA,+BAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;AAAN;;AAIA;EACE,kBAAA;EACA,gBAAA;AADF;;AAGA;EACE,kBAAA;AAAF;AACE;EACE,kBAAA;AACJ;AAAI;EAFF;IAGI,WAAA;IACA,YAAA;EAGJ;AACF;;AACA;EACE,kBAAA;AAEF;;AAEE;EACE,kBAAA;AACJ;;AAII;EADF;IAEI,YAAA;IACA,WAAA;IACA,gCAAA;IACA,kBAAA;IACA,8BAAA;IACA,kBAAA;IACA,WAAA;IACA,UAAA;EAAJ;EAIA;IAEI,aAAA;IACA,WAAA;IACA,6BAAA;IACA,kBAAA;IACA,8BAAA;IACA,kBAAA;IACA,WAAA;IACA,SAAA;EAAJ;EAIA;IAGI,iBAAA;EADJ;EAII;IACE,aAAA;IACA,WAAA;IACA,gCAAA;IACA,kBAAA;IACA,8BAAA;IACA,kBAAA;IACA,WAAA;IACA,UAAA;EAFN;AA5BF;;AAqCE;EACE,iBAAA;EACA,eAAA;AALJ;;AAQE;EACE,aAAA;EACA,mBAAA;EACA,WAAA;EACA,uBAAA;EACA,iBAAA;AALJ;AAOI;EACE,2BAAA;AALN;AAQI;EAXF;IAYI,YAAA;IACA,mBAAA;IACA,cAAA;IACA,kBAAA;EALJ;EAMI;IACE,mBAAA;EAJN;AACF;;AAOE;EACE,WAAA;EACA,gBAAA;AAJJ;;AAQI;EADF;IAEI,eAAA;EAJJ;AACF;;AAQI;EADF;IAEI,aAAA;IACA,WAAA;IACA,6BAAA;IACA,mBAAA;IACA,+BAAA;IACA,kBAAA;IACA,YAAA;IACA,SAAA;EAJJ;EAQA;IAEI,mBAAA;IACA,kBAAA;IACA,kBAAA;IACA,WAAA;IACA,WAAA;IACA,SAAA;EAJJ;EAQA;IAEI,kBAAA;IACA,WAAA;IACA,YAAA;IACA,WAAA;IACA,cAAA;IACA,WAAA;IACA,gCAAA;IACA,+BAAA;IACA,aAAA;EAJJ;AAxBF;;AAgCE;EACE,aAAA;EACA,uBAAA;AAJJ;;AAOE;EACE,uBAAA;EACA,YAAA;EACA,aAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,aAAA;EACA,2CAAA;EACA,kBAAA;AAJJ","sourcesContent":["$breakpoint-xs: 480px;\n$breakpoint-sm: 768px;\n$breakpoint-md: 925px;\n$breakpoint-lg: 1366px;\n\n.bracket-game-container {\n  width: 168px;\n  height: 123px;\n  margin-right: 24px;\n  display: block;\n  flex-direction: row;\n  position: relative;\n}\n\n// .bracketBox {\n//     width: 168px;\n//     padding: 8px 8px;\n//     margin-bottom: 16px;\n//     border-radius: 8px;\n//     border: 1px solid #9C9C9C;\n//     background: #FFF;\n//     box-shadow: 0px 1px 2px 0px rgba(0, 0, 0, 0.25);\n//   }\n.conference-title-container{\n  display: flex;\n  justify-content: space-between;\n  width: 95%;\n  max-width: 1290px;\n  margin: 32px auto;\n  @media screen and (max-width: $breakpoint-md) {\n    padding-left: 25px;\n  }\n}\n.conference-title{\n  color: #CECECE;\n  font-family: Inter;\n  font-size: 48px;\n  font-style: normal;\n  font-weight: 700;\n  line-height: normal;\n}\n.conference-title.right{\n  @media screen and (max-width: $breakpoint-md) {\n    display: none;\n  }\n}\n\n.conference-title-container.mobile{\n  display: none;\n  @media screen and (max-width: $breakpoint-md) {\n    display: block;\n  }\n\n}\n\n.conference-title.mobile{\n  display: none;\n  @media screen and (max-width: $breakpoint-md) {\n    display: block;\n    text-align: left;\n  }\n}\n\n.bracketBox {\n  width: 168px;\n  padding: 8px 8px;\n  border-radius: 8px;\n  border-right: 1px solid #efefef;\n  border-top: 1px solid #efefef;\n  border-left: 1px solid #efefef;\n  border-bottom: 1px solid #efefef;\n  background: #FFF;\n  box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.15);\n}\ninput[type=\"radio\"]:checked {\n  background-color: #002129;\n}\n.bracket-line-bottom {\n  height: 68px;\n  width: 12px;\n  border-bottom: 1px solid #9C9C9C;\n  border-right: 1px solid #9C9C9C;\n  position: absolute;\n  right: -12px;\n  top: -15px;\n}\n.bracket-line-top {\n  height: 68px;\n  width: 12px;\n  border-top: 1px solid #9C9C9C;\n  border-right: 1px solid #9C9C9C;\n  position: absolute;\n  right: -12px;\n  top: 55px;\n}\n\n  .row-text {\n    margin-bottom: 8px;\n    font-size: 16px;\n  }\n\n  .bottom-text {\n    margin-top: 8px;\n    font-size: 16px;\n  }\n\n\n  .team-section {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-bottom: 0px;\n  }\n\n  .team-name {\n    flex: 1;\n    font-size: 12px;\n  }\n\n  /* Score container */\n.team-score-container {\n  flex-shrink: 0; /* Prevents the score container from stretching */\n}\n\n  /* Bracket team container */\n.bracket-team-container {\n    display: flex;\n    width: 146px;\n    align-items: center;\n    gap: var(--1, 8px);\n    border-radius: var(--1, 8px);\n    background: #FFF;\n  }\n\n  /* Team logo */\n  .team-logo-svg {\n    width: 16px;\n    height: 16px;\n    fill: #EDEDED;\n    margin-right: 10px;\n  }\n\n  /* Team seed */\n  .team-seed {\n    width: 14px;\n    height: 15px;\n    color: #002129;\n    font-family: Inter;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n    margin-right: 10px;\n  }\n\n  .dropdown-select{\n    color: #002129;\n    text-align: center;\n    font-family: Inter;\n    font-size: 8px;\n    font-style: normal;\n    font-weight: 500;\n    width: 137px;\n    line-height: normal;\n    margin-bottom: 10px;\n  }\n\n  /* Team name */\n  .team-name {\n    width: 87px;\n    height: 15px;\n    color: #002129;\n    font-family: Inter;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 500;\n    line-height: normal;\n    white-space: nowrap;\n  }\n\n  .no-team-name {\n    width: 100%;\n    height: 12px;\n    fill: #D9D9D9;\n  }\n\n  .round-two-box-one{\n    margin-top: 60px;\n    .bracket-line-top{\n      height: 115px;\n      width: 12px;\n      border-top: 1px solid #9C9C9C;\n      border-right: 1px solid #9C9C9C;\n      position: absolute;\n      right: -12px;\n      top: 55px;\n    }\n  }\n\n  .back-line {\n    border-bottom: 1px solid #9C9C9C;\n    position: absolute;\n    width: 13px;\n    left: -13px;\n    top: 51px;\n}\n\n.column-one .bracket-game-container .back-line{\n  display: none;\n}\n.bottom-bracket {}\n.column-two .bracket-right-side-bottom .back-line{\n  right: -13px;\n  left: unset;\n  @media screen and (max-width: $breakpoint-md) {\n    left: -13px;\n    right: unset;\n  }\n}\n.column-two .bracket-right-side-top .back-line{\n  right: -13px;\n  left: unset;\n  @media screen and (max-width: $breakpoint-md) {\n    left: -13px;\n    right: unset ;\n  }\n}\n\n.column-final{\n  @media screen and (max-width: $breakpoint-md) {\n    margin-top: -201px;\n  }\n}\n\n.round-three-box-one.bracket-right-side-top .back-line{\n  display: none;\n\n}\n.bracket-game-container.round-final.bracket-right-side-top .bracket-line-bottom{\n  @media screen and (max-width: $breakpoint-md) {\n    display: none;\n    margin-right: 20px;\n  }\n}\n\n  .column-final{\n    @media screen and (min-width: $breakpoint-md) {\n      margin-top: 35px;\n    }\n\n  }\n\n  .champ-box{\n    width: 84px;\n    height:84px;\n    border-top-left-radius: 8px;\n    border-top-right-radius: 8px;\n    margin: 0px auto 0 auto;\n    border: 1px solid #efefef;\n    box-shadow: 0 0 5px #bababa;\n    background: #fff;\n  }\n\n  .champ-box img{\n    width: 85%;\n    margin: 10px auto;\n    display: block;\n  }\n\n  .champ-name{\n    background: #F2F2F2;\n    border-bottom-left-radius: 8px;\n    border-bottom-right-radius: 8px;\n    box-shadow: 0 0 5px #bababa;\n    width: 84px;\n    margin: 0 auto;\n    color: #ffffff;\n  }\n\n  .save-picks-btn{\n    background-color: #00AAD1 !important;\n    color:#ffffff !important;\n    font-weight: 700 !important;\n  }\n  .round-two-box-two{\n    margin-top: 125px;\n\n\n    .bracket-line-bottom{\n      height: 140px;\n      width: 12px;\n      border-bottom: 1px solid #9C9C9C;\n      border-right: 1px solid #9C9C9C;\n      position: absolute;\n      right: -12px;\n      top: -79px;\n\n    }\n  }\n.round-final{\n  margin-right: 11px;\n  margin-top: 20px;\n}\n.round-three-box-one.bracket-right-side-top{\n  margin-right: 23px;\n  .bracket-line-bottom{\n    border-right: none;\n    @media screen and (max-width: $breakpoint-md) {\n      left: -13px;\n      right: unset ;\n    }\n  }\n}\n\n.round-three-box-one .bracket-line-bottom{\n  border-right: none;\n}\n\n.round-final.bracket-right-side-top{\n  .bracket-line-bottom{\n    border-right:none;\n  }\n}\n\n  .bracket-right-side-bottom .bracket-line-bottom{\n    @media screen and (min-width: $breakpoint-md) {\n      height: 68px;\n      width: 12px;\n      border-bottom: 1px solid #9C9C9C;\n      border-right: none;\n      border-left: 1px solid #9C9C9C;\n      position: absolute;\n      left: -12px;\n      top: -15px;\n    }\n  }\n\n  .bracket-right-side-top .bracket-line-top{\n    @media screen and (min-width: $breakpoint-md) {\n      height: 115px;\n      width: 12px;\n      border-top: 1px solid #9C9C9C;\n      border-right: none;\n      border-left: 1px solid #9C9C9C;\n      position: absolute;\n      left: -12px;\n      top: 55px;\n    }\n  }\n\n  .round-two-box-two.bracket-right-side-bottom{\n\n    @media screen and (min-width: $breakpoint-md) {\n      margin-top: 125px;\n\n\n      .bracket-line-bottom{\n        height: 140px;\n        width: 12px;\n        border-bottom: 1px solid #9C9C9C;\n        border-right: none;\n        border-left: 1px solid #9C9C9C;\n        position: absolute;\n        left: -12px;\n        top: -79px;\n      }\n    }\n  }\n.round-three-box-one .bracket-line-bottom{\n\n}\n  .round-three-box-one{\n    margin-top: 185px;\n    margin-right:0;\n  }\n\n  .bracket-box-container{\n    display: flex;\n    align-items: center;\n    width:100%;\n    justify-content: center;\n    min-width: 1400px;\n\n    .bottom-bracket{\n      flex-direction: row-reverse;\n    }\n\n    @media screen and (max-width: $breakpoint-md) {\n      min-width: 0;\n      overflow-y: overlay;\n      display: block;\n      padding-left: 25px;\n      .bottom-bracket{\n        flex-direction: row;\n      }\n    }\n  }\n  .bracket-box-wrapper {\n    width: 100%;\n    overflow-x: auto\n  }\n\n  .column-one .bracket-right-side-top, .bracket-right-side-bottom{\n    @media screen and (min-width: $breakpoint-md) {\n      margin-right: 0;\n    }\n  }\n\n  .bracket-game-container.round-three-box-one .bracket-line-bottom{\n    @media screen and (max-width: $breakpoint-md) {\n      height: 232px;\n      width: 12px;\n      border-top: 1px solid #9C9C9C;\n      border-bottom: none;\n      border-right: 1px solid #9C9C9C;\n      position: absolute;\n      right: -11px;\n      top: 54px;\n    }\n  }\n\n  .bracket-game-container.round-three-box-one.bracket-right-side-top .bracket-line-bottom{\n    @media screen and (max-width: $breakpoint-md) {\n      border-bottom:none;\n      border-right: none;\n      position: absolute;\n      width: 13px;\n      left: -13px;\n      top: 51px;\n    }\n  }\n\n  .bracket-game-container.round-three-box-one.bracket-right-side-top .back-line{\n    @media screen and (max-width: $breakpoint-md) {\n      position: absolute;\n      width: 11px;\n      right: -11px;\n      top: -210px;\n      display: block;\n      left: unset;\n      border-bottom: 1px solid #9C9C9C;\n      border-right: 1px solid #9C9C9C;\n      height: 262px;\n    }\n  }\n\n  .userpick-content{\n    display: flex;\n    justify-content: center;\n  }\n\n  .tiebreaker-modal {\n    background-color: white;\n    width: 300px;\n    height: 500px;\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 20px;\n    box-shadow: 0px 2px 10px rgba(0, 0, 0, 0.1);\n    border-radius: 8px;\n  }\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
